import React from 'react';

import { ThemeContextType } from './types';

export const ThemeContext = React.createContext({} as ThemeContextType);
